
import ManageAuditNotFoundSvgComponent from '../../assets/svg-components/not-found/manage-audit';
import './index.scss';

export default function ManageAuditNotfound() {
  return (
    <>
      <div className="new-not-found-wrap">
        <div className="new-not-found-wrap__details">
          {/* <img
            src="/images/page-not-found/manage-audit.svg"
            className="not-found-image img-fluid"
          /> */}
          <div className="not-found-image">
            <ManageAuditNotFoundSvgComponent />
          </div>
          <p className="no-data-found-text">No information is available for the chosen month. Please either select a different month or add a vendor to the current month to view data.</p>
        </div>
      </div>
    </>
  );
}
